"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCampaignExactAggregator = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var types_1 = require("../../types");
var enums_1 = require("../../../../enums");
var DateTimeCheckService_1 = __importDefault(require("../../../DateTimeCheckService"));
var base_1 = require("../base");
var PromoDatesService_1 = require("./PromoDatesService");
var ACCURACY_TIME_IN_SECONDS = 60;
var AdCampaignExactAggregator = (function (_super) {
    __extends(AdCampaignExactAggregator, _super);
    function AdCampaignExactAggregator(adCampaigns, startTime, timezone, logger, tracing) {
        if (timezone === void 0) { timezone = moment_timezone_1.default.tz.guess(); }
        var _this = _super.call(this) || this;
        _this.promoDates = [];
        _this.promoDates = PromoDatesService_1.PromoDatesService.convertAdCampaignsToPromoDates(adCampaigns, (0, moment_timezone_1.default)(startTime), timezone);
        _this.promoDates = PromoDatesService_1.PromoDatesService.sortAndCorrectPromoDates(_this.promoDates, startTime);
        return _this;
    }
    AdCampaignExactAggregator.prototype.getTargetTime = function () {
        return null;
    };
    AdCampaignExactAggregator.prototype.getId = function () {
        return 0;
    };
    AdCampaignExactAggregator.prototype.getInsertInfo = function (_a) {
        var nextTime = _a.nextTime, rotations = _a.rotations, lastRotations = _a.lastRotations;
        var startInsertTime = nextTime.clone().subtract(ACCURACY_TIME_IN_SECONDS, "seconds");
        var insertedPromoIds = [];
        if (rotations.length) {
            var lastRotation = rotations[rotations.length - 1];
            if (lastRotation.campaignType !== enums_1.EAdCampaignType.EXACT) {
                return {
                    startInsertTime: (0, moment_timezone_1.default)(lastRotation.playtime),
                    insertedPromoIds: insertedPromoIds,
                };
            }
            for (var i = rotations.length - 1; i >= 0; i--) {
                var _b = rotations[i], playtime = _b.playtime, promoId = _b.promoId, campaignType = _b.campaignType;
                if (promoId && campaignType === enums_1.EAdCampaignType.EXACT) {
                    insertedPromoIds.push(promoId);
                }
                if (campaignType !== enums_1.EAdCampaignType.EXACT) {
                    return {
                        startInsertTime: (0, moment_timezone_1.default)(playtime),
                        insertedPromoIds: insertedPromoIds,
                    };
                }
            }
            startInsertTime = (0, moment_timezone_1.default)(rotations[0].playtime);
        }
        var isHistoryInAccuracyTime = (lastRotations === null || lastRotations === void 0 ? void 0 : lastRotations.length) &&
            lastRotations[lastRotations.length - 1].endTime &&
            (0, moment_timezone_1.default)(lastRotations[lastRotations.length - 1].endTime).isAfter(nextTime.clone().subtract(ACCURACY_TIME_IN_SECONDS, "seconds"));
        if (isHistoryInAccuracyTime && (lastRotations === null || lastRotations === void 0 ? void 0 : lastRotations.length)) {
            for (var i = lastRotations.length - 1; i >= 0; i--) {
                var _c = lastRotations[i], playtime = _c.playtime, promoId = _c.promoId, campaignType = _c.campaignType;
                if (promoId && campaignType === enums_1.EAdCampaignType.EXACT) {
                    insertedPromoIds.push(promoId);
                }
                startInsertTime = (0, moment_timezone_1.default)(playtime);
                if (campaignType !== enums_1.EAdCampaignType.EXACT) {
                    return {
                        startInsertTime: startInsertTime,
                        insertedPromoIds: insertedPromoIds,
                    };
                }
            }
        }
        return {
            startInsertTime: startInsertTime,
            insertedPromoIds: insertedPromoIds,
        };
    };
    AdCampaignExactAggregator.prototype.isRotationMustBeInserted = function (_a) {
        var startInsertTime = _a.startInsertTime, nextTime = _a.nextTime, promoDate = _a.promoDate, rotationPlaytime = _a.rotationPlaytime;
        if (!DateTimeCheckService_1.default.checkNextTimeForObject(promoDate, rotationPlaytime)) {
            return false;
        }
        var insertRangeEndTime = nextTime.clone();
        return promoDate.date.isBetween(startInsertTime, insertRangeEndTime, null, "[]");
    };
    AdCampaignExactAggregator.prototype.getPlaytime = function (_a) {
        var lastRotation = _a.lastRotation, nextTime = _a.nextTime, promoTime = _a.promoTime;
        if (!lastRotation || lastRotation.campaignType)
            return nextTime;
        if (promoTime.isBefore(lastRotation.playtime))
            return lastRotation.playtime;
        return promoTime;
    };
    AdCampaignExactAggregator.prototype.getRotation = function (_a) {
        var _this = this;
        var rotations = _a.rotations, nextTime = _a.nextTime, lastRotations = _a.lastRotations;
        var isFirstRotation = !rotations.length;
        var lastRotation = isFirstRotation ? undefined : rotations[rotations.length - 1];
        var _b = this.getInsertInfo({
            rotations: rotations,
            nextTime: nextTime,
            lastRotations: lastRotations,
        }), startInsertTime = _b.startInsertTime, insertedPromoIds = _b.insertedPromoIds;
        var rotationPlaytime;
        var promoDateForInsertion = this.promoDates.find(function (promoDate) {
            rotationPlaytime = _this.getPlaytime({
                lastRotation: lastRotation,
                nextTime: nextTime,
                promoTime: promoDate.date,
            });
            return (!insertedPromoIds.includes(promoDate.promoId) &&
                _this.isRotationMustBeInserted({
                    startInsertTime: startInsertTime,
                    nextTime: nextTime,
                    promoDate: promoDate,
                    rotationPlaytime: rotationPlaytime,
                }));
        });
        if (!rotationPlaytime || !promoDateForInsertion) {
            return new types_1.GetRotationSkip();
        }
        if ((lastRotation === null || lastRotation === void 0 ? void 0 : lastRotation.campaignType) && lastRotation.campaignType !== enums_1.EAdCampaignType.EXACT) {
            return new types_1.GetRotationError();
        }
        return this.convertPromoToRotation({
            mediafileData: promoDateForInsertion.mediafileData,
            insertTime: rotationPlaytime,
            campaignType: enums_1.EAdCampaignType.EXACT,
            adcompanyId: promoDateForInsertion.adcampaignId,
            priority: 10,
        });
    };
    return AdCampaignExactAggregator;
}(base_1.AdGeneratorAbstract));
exports.AdCampaignExactAggregator = AdCampaignExactAggregator;
//# sourceMappingURL=index.js.map